import { render, staticRenderFns } from "./svg-sprite.vue?vue&type=template&id=44c472c8&scoped=true"
var script = {}
import style0 from "./svg-sprite.vue?vue&type=style&index=0&id=44c472c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c472c8",
  null
  
)

export default component.exports